module.exports = __webpack_public_path__ + "media/images/appstore-43ff0abb7747f9411caa0c566d118ed6.png";